export default "__VITE_ASSET__BCRgMtip__"